import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["editMode", "value", "numberOfMonths", "classes", "InputProps", "onChange", "name", "popperVariant", "popperPlacement", "hideSuffix", "weight"],
  _excluded2 = ["children"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
//@ts-nocheck
import { Icon, Popper, withStyles, ClickAwayListener, Box, IconButton } from "components/mui";
import classNames from "classnames";
import DateFormater from "components/Formaters/DateFormater/DateFormater";
import moment from "moment";
import React, { useEffect } from "react";
import { DayPickerSingleDateController } from "react-dates";
import TextField from "../TextField/TextField";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var POPPER_VARIANTS = {
  STICKY: "sticky"
};
function DateField(_ref) {
  var _ref$editMode = _ref.editMode,
    editMode = _ref$editMode === void 0 ? true : _ref$editMode,
    value = _ref.value,
    _ref$numberOfMonths = _ref.numberOfMonths,
    numberOfMonths = _ref$numberOfMonths === void 0 ? 1 : _ref$numberOfMonths,
    classes = _ref.classes,
    _ref$InputProps = _ref.InputProps,
    InputProps = _ref$InputProps === void 0 ? {} : _ref$InputProps,
    _onChange = _ref.onChange,
    name = _ref.name,
    popperVariant = _ref.popperVariant,
    _ref$popperPlacement = _ref.popperPlacement,
    popperPlacement = _ref$popperPlacement === void 0 ? "bottom-start" : _ref$popperPlacement,
    hideSuffix = _ref.hideSuffix,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? "regular" : _ref$weight,
    props = _objectWithoutProperties(_ref, _excluded);
  var date;
  if (value) {
    date = moment(value);
  } else {
    date = "";
  }
  var maybeDateStr = date ? date.format("MM/DD/YYYY") : "";
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showPicker = _React$useState2[0],
    setShowPicker = _React$useState2[1];
  var _React$useState3 = React.useState(maybeDateStr),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    textValue = _React$useState4[0],
    setTextValue = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    inputRef = _React$useState6[0],
    setInputRef = _React$useState6[1];
  useEffect(function () {
    if (!value) {
      setTextValue("");
    }
  }, [value]);
  var onDateChange = function onDateChange(date) {
    setShowPicker(false);
    if (_onChange) {
      var _maybeDateStr = date ? date.format("YYYY-MM-DD") : null;
      _onChange({
        target: {
          value: _maybeDateStr,
          name: name
        }
      });
    }
    var nextTextValue = date ? date.format("MM/DD/YYYY") : "";
    setTextValue(nextTextValue);
  };
  var clearDate = function clearDate() {
    if (_onChange) {
      setTextValue("");
      _onChange({
        target: {
          value: null,
          name: name
        }
      });
    }
  };
  if (!editMode) {
    return /*#__PURE__*/_jsx(DateFormater, {
      value: value,
      weight: weight
    });
  }
  var isSticky = popperVariant === POPPER_VARIANTS.STICKY;
  var Popper = isSticky ? StickyPopper : DefaultPopper;
  return /*#__PURE__*/_jsx(ClickAwayListener, {
    onClickAway: function onClickAway() {
      return setShowPicker(false);
    },
    children: /*#__PURE__*/_jsxs("div", {
      style: {
        position: isSticky ? "relative" : undefined,
        width: "100%"
      },
      children: [/*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, props), {}, {
        value: textValue,
        suffix: !hideSuffix && /*#__PURE__*/_jsx(IconButton, {
          onClick: clearDate,
          className: classes.deleteIconBtn,
          children: /*#__PURE__*/_jsx(Icon, {
            className: classNames("fal fa-times", classes.deleteIcon)
          })
        }),
        "data-testid": "date-available-input",
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          setTextValue(value);
          var date = moment(value, "MM/DD/YYYY");
          if (date.isValid()) {
            var _maybeDateStr2 = date ? date.format("YYYY-MM-DD") : null;
            _onChange({
              target: {
                value: _maybeDateStr2,
                name: name
              }
            });
          } else if (value === "") {
            clearDate();
          }
        },
        onKeyDown: function onKeyDown(event) {
          if (event.key === "Enter") {
            setShowPicker(false);
          }
        },
        InputProps: _objectSpread(_objectSpread({}, InputProps), {}, {
          //readOnly: true,
          inputRef: function inputRef(component) {
            setInputRef(component);
          },
          name: "date-field"
        }),
        onFocus: function onFocus() {
          setShowPicker(true);
        },
        autoComplete: "off"
      })), /*#__PURE__*/_jsx(Popper, {
        placement: popperPlacement,
        className: classes.popper,
        anchorEl: inputRef,
        open: showPicker,
        onClose: function onClose() {
          return setShowPicker(false);
        },
        disablePortal: true // for easier testing and ClickAwayListener
        ,
        children: /*#__PURE__*/_jsx(DayPickerSingleDateController, {
          numberOfMonths: numberOfMonths,
          hideKeyboardShortcutsPanel: true,
          enableOutsideDays: true,
          isOutsideRange: function isOutsideRange() {
            return false;
          } // needed to select dates outside range  https://github.com/airbnb/react-dates/issues/470
          ,
          onDateChange: onDateChange,
          onFocusChange: function onFocusChange() {},
          date: value ? moment(value, "YYYY-MM-DD") : null,
          focused: true
        })
      })]
    })
  });
}
function StickyPopper(props) {
  var stickyProps = _objectSpread(_objectSpread({}, props), {}, {
    // https://github.com/popperjs/popper.js/blob/master/docs/_includes/popper-documentation.md#modifiers
    modifiers: _objectSpread(_objectSpread({}, props.modifiers || {}), {}, {
      flip: {
        // should popper flip if it hits a boundary element?
        enabled: false
      },
      // disabling preventOverflow and hide fixes a bug where the calendar prev month btn was not interactive until the 2nd click.
      // also, the popper sticks to the ref element so overflow and hide logic can be disabled
      preventOverflow: {
        enabled: false
      },
      hide: {
        enabled: false
      }
    }),
    // https://github.com/popperjs/popper.js/blob/master/docs/_includes/popper-documentation.md#Popper.Defaults
    popperOptions: _objectSpread(_objectSpread({}, props.popperOptions || {}), {}, {
      // should popper reposition when resized or scroll event happens?
      eventsEnabled: false
    })
  });
  return /*#__PURE__*/_jsx(Popper, _objectSpread({}, stickyProps));
}

/*
 * A min-height Box is needed b/c Popper doesn't know the dimensions of DayPickerSingleDateController on first render.
 * Therefore, it always renders children below, even if the calendar is partially hidden offscreen/offmodal.
 * Fix for: proposal upload modal when the date is the last field
 */
function DefaultPopper(_ref3) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded2);
  return /*#__PURE__*/_jsx(Popper, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx(Box, {
      minHeight: 300,
      children: children
    })
  }));
}
var styles = function styles(theme) {
  return {
    popper: {
      zIndex: 10000000000000
    },
    dateContainer: {
      paddingTop: 20
    },
    deleteIcon: {
      fontSize: 16
    },
    deleteIconBtn: {
      padding: 4
    }
  };
};
export default withStyles(styles)(DateField);